export interface IHasUnconnectedDocuments {

    documentIdsToConnect: Array<string>;

}

export function isInstanceOfHasUnconnectedDocuments(object: any): object is IHasUnconnectedDocuments {
    return 'documentIdsToConnect' in object;
}




// WEBPACK FOOTER //
// ./src/app/models/IHasUnconnectedDocuments.ts